module.exports = __webpack_public_path__ + "img/business-icon.4330daec.svg";